<template>
  <div>
    <!-- Hero Section -->
    <section class="pt-32 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center">
          <h1 class="text-5xl md:text-6xl font-headings mb-6 text-secondary-900">
            Get in Touch
            
          </h1>
          <p class="text-xl text-secondary-600 max-w-xl mx-auto">
            Have questions about our event management platform? We'd love to hear from you.
          </p>
        </div>
      </div>
    </section>

    <ContentWrapper>
      <div class="py-12 max-w-3xl mx-auto">
        <div ref="hubspotFormRef" id="hubspot-form-container">

          <div class="h-96 flex items-center justify-center">
            Loading...
          </div>

        </div>
      </div>
    </ContentWrapper>

    <CtaSignup />
    
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue'
import CtaSignup from '@/components/Blocks/CtaSignup.vue'

const hubspotFormRef = ref(null)

function loadHubSpotForm() {
  if (typeof hbspt === 'undefined') {
    const script = document.createElement('script')
    script.src = '//js-ap1.hsforms.net/forms/embed/v2.js'
    script.charset = 'utf-8'
    script.async = true
    script.onload = () => createHubSpotForm()
    document.head.appendChild(script)
  } else {
    createHubSpotForm()
  }
}

function createHubSpotForm() {
  if (hubspotFormRef.value && typeof hbspt !== 'undefined') {
    hbspt.forms.create({
      portalId: '20525915',
      formId: '252302f9-7664-4b02-8ac7-f8840fd1767d',
      region: 'ap1',
      target: '#hubspot-form-container'
    })
  }
}

onMounted(() => {
  loadHubSpotForm()
})
</script>